<script setup lang="ts">
const { status, signOut } = useAuth();
const isLoggedIn = computed(() => status.value === "authenticated");
</script>
<template>
  <div
    class="bg-cerise-red-600 text-white w-full h-svh z-40 flex text-center items-center flex-col justify-between"
  >
    <h2 @click="$emit('menu', false)" class="ml-auto mt-5 mr-5">
      <nuxt-img
        src="images/close-white.svg"
        class="w-5 float-right cursor-pointer"
      />
    </h2>
    <div
      v-if="!isLoggedIn"
      class="px-[26px] py-3 bg-cerise-red-600 border border-white text-white rounded-[36px] text-base leading-5 tracking-wide"
    >
      <nuxt-link @click="$emit('menu', false)" to="/login">
        ACCEDI O REGISTRATI
      </nuxt-link>
    </div>
    <div v-else>
      <nuxt-link @click="$emit('menu', false)" to="/profile">
        <div
          class="px-7 py-3 bg-cerise-red-600 border border-white text-white rounded-lg text-base leading-5 tracking-wide"
        >
          Bacheca
        </div>
      </nuxt-link>

      <div class="mt-14">
        <CorePrimaryButton
          @click="[$emit('menu', false), signOut({ callbackUrl: '/' })]"
        >
          Logout
        </CorePrimaryButton>
      </div>
    </div>
    <div class="flex mb-9">
      <nuxt-link
        class="flex"
        @click="$emit('menu', false)"
        to="https://www.prenatal.com"
        target="_blank"
      >
        <nuxt-img src="images/badges/shopping-cart-white.svg" class="w-5" />
        <span class="ml-2 font-bold mr-7">Store online</span>
      </nuxt-link>
    </div>
  </div>
</template>

<style></style>
